import { render, staticRenderFns } from "./button-generic-v2.vue?vue&type=template&id=fe745014&"
import script from "./button-generic-v2.vue?vue&type=script&lang=ts&"
export * from "./button-generic-v2.vue?vue&type=script&lang=ts&"
import style0 from "./button-generic-v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports